import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { PermissionCatalogItem } from '../rolePermissions/rolePermissionsSlice';

export interface SelectedPermissionUser {
  id: number;
  username: string;
  email: string;
  roles: string[];
}

export interface UserPermissionOverridesState {
  selectedUser: SelectedPermissionUser | null;
  basePermissions: string[];
  effectivePermissions: string[];
  catalog: PermissionCatalogItem[];
}

export const initialState: UserPermissionOverridesState = {
  selectedUser: null,
  basePermissions: [],
  effectivePermissions: [],
  catalog: [],
};

export const userPermissionOverridesSlice = createSlice({
  name: 'userPermissionOverrides',
  initialState,
  reducers: {
    setUserPermissions: (
      state,
      action: PayloadAction<{
        selectedUser: SelectedPermissionUser;
        basePermissions: string[];
        effectivePermissions: string[];
        catalog: PermissionCatalogItem[];
      }>,
    ) => {
      state.selectedUser = action.payload.selectedUser;
      state.basePermissions = action.payload.basePermissions;
      state.effectivePermissions = action.payload.effectivePermissions;
      state.catalog = action.payload.catalog;
    },
    clearUserPermissions: (state) => {
      state.selectedUser = null;
      state.basePermissions = [];
      state.effectivePermissions = [];
      state.catalog = [];
    },
    toggleEffectivePermission: (state, action: PayloadAction<string>) => {
      const permission = action.payload;
      state.effectivePermissions = state.effectivePermissions.includes(permission)
        ? state.effectivePermissions.filter((p) => p !== permission)
        : [...state.effectivePermissions, permission];
    },
    setEffectivePermissionList: (state, action: PayloadAction<string[]>) => {
      state.effectivePermissions = Array.from(new Set(action.payload));
    },
  },
});

export const {
  setUserPermissions,
  clearUserPermissions,
  toggleEffectivePermission,
  setEffectivePermissionList,
} = userPermissionOverridesSlice.actions;
export default userPermissionOverridesSlice.reducer;
